import { useEffect, useRef, useState } from "react";
import useFirebaseConfig from "shared/hooks/useFirebaseConfig";
import { defaultReportSetting } from "../reportDefaults";
import { saveReportWithSettings } from "../reportWrites";
import{ word, sentence, video, setting } from "shared/types/Report";
import useFirestore from "shared/hooks/useFirestore";
import useGetBranchId from "shared/hooks/useGetBranchId";

const baseSetting = defaultReportSetting;

const useReportView = (selected_report:string, now_folder:string, viewer:boolean | undefined) => {
    const path = now_folder + "/" + selected_report;
    const {getBranchId} = useGetBranchId();
    const {readFirestore, readFirestoreOneDoc} = useFirestore();
    const { dbFirestore } = useFirebaseConfig();
    const saving = useRef(false);
    const [isRegisterSucceed, setIsRegisterSucceed] = useState(false);
    const [isRegisterFailed, setIsRegisterFailed] = useState(false);
    const [selectedReportType, setSelectedReportType] = useState(1);
    const [wordList, setWordList] = useState<word[]>([]);
    const [sentenceList, setSentenceList] = useState<sentence[]>([]);
    const [videoList, setVideoList] = useState<video[]>([]);
    const [setting, setSetting] = useState<setting>(baseSetting);
    useEffect(() => {
        setWordList([]);
        setSentenceList([]);
        setVideoList([]);
        setSetting(baseSetting);
        getReportLists();
    },[selected_report, now_folder, viewer])
  
    const navItem = [
        {
            id:1,
            name:"단어",
            type:"word"
        },
        {
            id:2,
            name:"문장",
            type:"sentence"
        },
        {
            id:3,
            name:"동영상",
            type:"video"
        },
        {
            id:4,
            name:"학습설정",
            type:"setting"
        },
    ]

    const onReportTypeClickHandler = (id:number) => {
        setSelectedReportType(id);
    }
    const onRegisterAllReportClickHandler = async () => {
        if (saving.current || !selected_report) return;
        saving.current = true;
        try {
            await saveReportWithSettings(dbFirestore, path, { word: wordList, sentence: sentenceList, video: videoList }, setting);
            setIsRegisterSucceed(true);
        } catch (error) {
            console.error("과제 및 학습설정 저장 실패:", error);
            setIsRegisterFailed(true);
        } finally {
            saving.current = false;
        }
    };

    const onRegisterSucceedModalConfirmHandler = () => {
        setIsRegisterSucceed(false);
    }

    const onRegisterFaildModalConfirmHandler = () => {
        setIsRegisterFailed(false);
    }

    const getReportLists = async() => {
        if(selected_report){
            const branch_id = await getBranchId();
            let reportPermission = await readFirestoreOneDoc("User/Auth/Branch", branch_id).then(res => {
                if(res.exists()){
                    return res.data().report_permission;
                }else{
                    return {word:false, sentence:false, video:false}
                }
            })
            if(!viewer){
                reportPermission = {word:true, sentence:true, video:true};
            }
            await readFirestore(now_folder + "/" + selected_report + "/Content").then(res => {
                const document_list = res.docs;
                const document_list_length = res.docs.length;
                for(let i = 0; i < document_list_length; i++){
                    const document = document_list[i];
                    const content = document.data().content;
                    if(document.id === "word" && reportPermission.word){
                        setWordList(content);
                    }else if(document.id === "sentence" && reportPermission.sentence){
                        setSentenceList(content)
                    }else if(document.id === "video" && reportPermission.video){
                        setVideoList(content);
                    }else if(document.id === "setting"){
                        const setting = document.data();
                        setSetting(setting);
                    }
                }
            })
        }
    }
    
    const onAudioDeleteHandler = (index: number) => {
        setSentenceList(prev => {
            const newList = [...prev];
            newList[index] = {
                ...newList[index],
                audio: ""
            };
            return newList;
        });
    }

    return {navItem, selectedReportType, onReportTypeClickHandler,
        path, wordList, setWordList, sentenceList, setSentenceList, videoList, setVideoList, 
        onRegisterAllReportClickHandler, setting, setSetting, 
        isRegisterSucceed, onRegisterSucceedModalConfirmHandler,
        isRegisterFailed, onRegisterFaildModalConfirmHandler,
        onAudioDeleteHandler
    }
}

export default useReportView;
